import React from 'react'
import { useTranslation } from 'react-i18next'
import BankAccountPage from './BankAccountPage'
import RequiredDocuments from './RequiredDocuments'
import { Enum } from '../../data/types/constants'
import CreditApplicationContainerStepProgressIcon from './CreditApplicationContainerStepProgressIcon'
import { useAppSelector } from '../../data/store'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'

export default function BankAccountInformationForm() {
  const { t } = useTranslation()
  const creditApplication = useAppSelector(creditApplicationSelectors.getFilteredCreditApplication)
  const stepProgression = <CreditApplicationContainerStepProgressIcon currentStep={3} />

  const bankAccountRequest =
    creditApplication?.requiredExternalSteps.some(
      (x) => x.status === Enum.ERequiredExternalStepStatus.WaitingForClient && x.externalStepId === 'bankAccount',
    ) && creditApplication.finalDecision.decision === Enum.EDecision.Approved
  const areAllIncomeConfirmed = creditApplication?.allIncomesConfirmed

  return (
    <main className="general-message" style={{ paddingTop: '15rem' }}>
      {bankAccountRequest && !areAllIncomeConfirmed && (
        <div style={{ zIndex: '1' }}>
          {stepProgression}
          <h1>{t('bankAccount.validateIncome')}</h1>
          <br />
          <h3>{t('bankAccount.seemless')}</h3>
          <div className="paragraph">
            <h3>{t('bankAccount.firstStep')}</h3>
            <p>{t('bankAccount.connectToBank')}</p>

            <h3>{t('bankAccount.secondStep')}</h3>
            <p>{t('bankAccount.permission')}</p>

            <h3>{t('bankAccount.thirdStep')}</h3>
            <p>{t('bankAccount.systemAnalysis')}</p>

            <p style={{ fontSize: '1.3rem' }}>
              {t('bankAccount.partnerInfo')} {t('bankAccount.clickToProceed')}
            </p>
          </div>
          <BankAccountPage />
        </div>
      )}
      <RequiredDocuments />
    </main>
  )
}
